import { NavInfoCardStack } from "@/components/nav-info-card-stack";

export function NavInfoCard() {
  // Define your updates here - add as many as you need!
  const updates = [
    // {
    //   id: "two-factor-auth",
    //   storageKey: "sidebar-update-2fa-v1",
    //   title: "New: Two-Factor Authentication",
    //   description: "Secure your account with 2FA. Enable it in Settings → Security using authenticator apps or backup codes.",
    //   media: [
    //     {
    //       src: "...",
    //       alt: "Two-Factor Authentication",
    //     },
    //   ],
    //   shrinkHeight: 65,
    //   expandHeight: 110,
    // },
  ];

  return <NavInfoCardStack updates={updates} />;
}

